/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import SelectList from './select-list';

const OptionsDropDown = (props) => (
    <section className={props.className}>
        {props.label ? (
            <h3 className={`${props.isRequired ? 'form-group-title asterisk-after' : 'form-group-title optional-criteria'}`}>
                <FormattedMessage id={props.label} />
            </h3>
        ) :
            null
        }
        <SelectList
            alwaysCallOnChange={props.alwaysCallOnChange}
            isPlaceholderTranslated={props.isPlaceholderTranslated}
            onChange={props.onChange}
            optionDisplayAttributes={props.optionDisplayAttributes}
            optionKey={props.optionKey}
            options={props.options}
            placeholder={props.placeholder}
            selectedValue={props.selectedValue}
            showPlaceholder={props.showPlaceholder}
        />
    </section>
);

OptionsDropDown.displayName = 'OptionsDropDown';
OptionsDropDown.propTypes = {
    alwaysCallOnChange: PropTypes.bool,
    className: PropTypes.string.isRequired,
    isPlaceholderTranslated: PropTypes.bool.isRequired,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    optionDisplayAttributes: PropTypes.arrayOf(PropTypes.string).isRequired,
    optionKey: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    placeholder: PropTypes.string.isRequired,
    selectedValue: PropTypes.string,
    showPlaceholder: PropTypes.bool,
};
OptionsDropDown.defaultProps = {
    alwaysCallOnChange: false,
    showPlaceholder: true,
};

export default OptionsDropDown;
